import React from 'react';
import { MapPinIcon, DollarSignIcon, UsersIcon, HomeIcon } from 'lucide-react';
import { PropertyData, LoanData, Parties } from '../types';
interface PropertySidebarProps {
  property: PropertyData;
  loan: LoanData;
  parties: Parties;
}
export function PropertySidebar({
  property,
  loan,
  parties
}: PropertySidebarProps) {
  const borrowers = parties.borrowers;
  const sellers = parties.sellers;
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0
    }).format(amount);
  };
  return <div className="bg-white rounded-lg shadow-sm border border-slate-200 overflow-hidden sticky top-0" data-id="element-104">
      <div className="px-4 py-3 border-b border-slate-100 bg-slate-50/50" data-id="element-105">
        <h2 className="text-sm font-semibold text-slate-900" data-id="element-106">Order Summary</h2>
      </div>

      <div className="divide-y divide-slate-100" data-id="element-107">
        {/* Property Section */}
        <div className="p-4" data-id="element-108">
          <div className="flex items-center text-slate-900 font-medium mb-2 text-xs uppercase tracking-wider" data-id="element-109">
            <MapPinIcon className="h-3.5 w-3.5 mr-1.5 text-slate-400" data-id="element-110" />
            Property
          </div>
          <div className="pl-5 text-xs text-slate-600 space-y-0.5 leading-relaxed" data-id="element-111">
            <p className="font-medium text-slate-800" data-id="element-112">{property.address1}</p>
            {property.address2 && <p data-id="element-113">{property.address2}</p>}
            <p data-id="element-114">
              {property.city}, {property.state} {property.zip}
            </p>
            <p className="text-slate-400" data-id="element-115">{property.county} County</p>
          </div>
        </div>

        {/* Loan Section */}
        <div className="p-4" data-id="element-116">
          <div className="flex items-center text-slate-900 font-medium mb-2 text-xs uppercase tracking-wider" data-id="element-117">
            <DollarSignIcon className="h-3.5 w-3.5 mr-1.5 text-slate-400" data-id="element-118" />
            Loan
          </div>
          <div className="pl-5 space-y-2.5" data-id="element-119">
            <div className="flex items-baseline justify-between" data-id="element-120">
              <span className="text-[10px] text-slate-400 uppercase tracking-wider font-medium" data-id="element-121">
                Loan Amount
              </span>
              <span className="text-sm font-semibold text-slate-900" data-id="element-122">
                {formatCurrency(loan.amount)}
              </span>
            </div>
            <div className="flex items-baseline justify-between" data-id="element-123">
              <span className="text-[10px] text-slate-400 uppercase tracking-wider font-medium" data-id="element-124">
                Purchase Price
              </span>
              <span className="text-sm font-semibold text-slate-900" data-id="element-125">
                {formatCurrency(loan.purchasePrice)}
              </span>
            </div>
            <div className="flex items-baseline justify-between" data-id="element-126">
              <span className="text-[10px] text-slate-400 uppercase tracking-wider font-medium" data-id="element-127">
                Type
              </span>
              <span className="text-xs text-slate-700 font-medium" data-id="element-128">
                {loan.type}
              </span>
            </div>
            <div className="flex items-baseline justify-between" data-id="element-129">
              <span className="text-[10px] text-slate-400 uppercase tracking-wider font-medium" data-id="element-130">
                Purpose
              </span>
              <span className="text-xs text-slate-700 font-medium" data-id="element-131">
                {loan.purpose}
              </span>
            </div>
          </div>
        </div>

        {/* Borrowers Section */}
        <div className="p-4" data-id="element-132">
          <div className="flex items-center text-slate-900 font-medium mb-2 text-xs uppercase tracking-wider" data-id="element-133">
            <UsersIcon className="h-3.5 w-3.5 mr-1.5 text-slate-400" data-id="element-134" />
            Borrowers
          </div>
          <div className="pl-5 space-y-2.5" data-id="element-135">
            {borrowers.map(borrower => <div key={borrower._id} data-id="element-136">
                <p className="text-xs font-medium text-slate-800" data-id="element-137">
                  {borrower.first_name} {borrower.last_name}
                </p>
                <p className="text-[10px] text-slate-400 leading-relaxed" data-id="element-138">
                  {borrower.email}
                </p>
              </div>)}
          </div>
        </div>

        {/* Sellers Section */}
        {sellers.length > 0 && <div className="p-4" data-id="element-139">
            <div className="flex items-center text-slate-900 font-medium mb-2 text-xs uppercase tracking-wider" data-id="element-140">
              <HomeIcon className="h-3.5 w-3.5 mr-1.5 text-slate-400" data-id="element-141" />
              Sellers
            </div>
            <div className="pl-5 space-y-2.5" data-id="element-142">
              {sellers.map(seller => <div key={seller._id} data-id="element-143">
                  <p className="text-xs font-medium text-slate-800" data-id="element-144">
                    {seller.first_name} {seller.last_name}
                  </p>
                  <p className="text-[10px] text-slate-400 leading-relaxed" data-id="element-145">
                    {seller.email}
                  </p>
                </div>)}
            </div>
          </div>}
      </div>
    </div>;
}